'use client';

import { BlogArticlesBlock, IPostInfo, IPostsListResponse } from '@sapientpro/sapientpro-data-models';
import { useEffect, useState } from 'react';
import CategoryBlock from './CategoryBlock';
import apiClient from '../../../apiClient';
import NotFound from '../../../app/not-found';
import styles from './CategoriesSection.module.scss';

const getArticles = async (slug: string) => {
  try {
    return await apiClient.get<IPostsListResponse>(
      `posts?${new URLSearchParams(JSON.parse(JSON.stringify({
        limit: 4,
        offset: 0,
        us: false,
        category: slug,
      })))}`,
      {
        cache: 'no-cache',
      },
    );
  } catch (e) {
    console.error(e.message);
    if (e.message.includes('404')) {
      NotFound();
    }
  }
};

const CategorySection = ({ data }: { data: BlogArticlesBlock }) => {
  const [posts, setPosts] = useState<IPostInfo[]>([]);

  const fetchPosts = async () => {
    try {
      const response = await getArticles(data.category.slug);

      setPosts(response?.posts || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, [data.category.slug]);

  return (
    <CategoryBlock
      index={0}
      category={{
        id: data.id,
        title: data.title,
        posts,
        slug: data.category.slug,
      }}
      className={styles.separatedCategory}
      containerModifier='home-page'
      headerLevel='h2'
      withoutLink
    />
  );
};

export default CategorySection;
